<template>
  <div class="team-view-page">
    <div class="team-view-page__top__buttons">
      
      <app-back-button
        class="team-view-page__top__buttons__back__button"
        route-name="team"
        i18n-code="entities.team.list.title"
      />

      <router-link
        v-if="record && record.id"
        class="team-view-page__top__buttons__edit__button"
        :to="`/team/${record.id}/edit`"
      >
        <el-button type="primary">
          <app-i18n code="entities.team.edit.title" />
        </el-button>
      </router-link>

    </div>

    <div
      class="app-content-page team-view-page__content"
      v-if="loading"
      v-loading="loading">
    </div>


    <div
      class="app-content-page team-view-page__content"
      v-else-if="record"
    >
      <app-team-view-toolbar v-if="record"/>

      <div class="team-view-page__content__header">
        <h2 class="team-view-page__content__subtitle">
          <span v-text="record.name" />
          <span class="team-view-page--margin-dot"> - </span>
          <span
            v-text="nameSubprogram"
            class="team-view-page__content__subtitle--light"
          />
        </h2>

        <!-- TODO: Create route to add players in team -->
        <!-- <router-link
          class="team-view-page__top__buttons__add__button"
          to="#add_player"
        >
          <el-button
            type="secondary"
          >
            <app-i18n code="entities.player.add.many" />
          </el-button>
        </router-link> -->
      </div>

      <div class="team-view-page__content__program">
        <span v-text="nameProgram"></span>
      </div>

      <!-- Coaches -->
      <div v-if="record.coaches.length" class="team-view-page__content__card__title">
        <app-i18n code="entities.coach.label"/>
      </div>

      <div v-if="record.coaches.length" class="team-view-page__content__card">
        <el-row class="team-view-page__content__card__header">
          <!-- Name -->
          <el-col :lg="6" :md="6" :sm="24">
            <app-i18n code="entities.team.fields.name"/>
          </el-col>
          <!-- Type -->
          <el-col :lg="6" :md="6" :sm="24">
            <app-i18n code="entities.coach.fields.type" />
          </el-col>
          <!-- Teams -->
          <el-col :lg="6" :md="6" :sm="24">
            <app-i18n code="entities.coach.fields.teams" />              
          </el-col>
          <!-- Email -->
          <el-col :lg="6" :md="6" :sm="24">
            <app-i18n code="entities.coach.fields.email" />              
          </el-col>
        </el-row>
        <el-row class="team-view-page__content__card__body" v-for="coach in record.coaches" :key="coach.id">
          <!-- Name -->
          <el-col :lg="6" :md="6" :sm="24">
            <span>{{presenterCoach(coach, 'firstName')}}  {{presenterCoach(coach, 'lastName')}}</span>
          </el-col>
          <!-- Type -->
          <el-col :lg="6" :md="6" :sm="24">
            <span>{{presenterCoach(coach, 'type')}}</span>
          </el-col>
          <!-- Teams -->
          <el-col :lg="6" :md="6" :sm="24">
            <app-i18n
              v-if="!coach.teams || !coach.teams.length"
              code="common.none"
            />
            <span
              v-else-if="coach.teams.length === 1"
            >
              {{coach.teams[0].name}}
            </span>
            <el-tooltip
              v-else-if="coach.teams.length > 1"
              effect="dark"
              :content="coach.teams.map(coach => coach.name).join('\n')"
              placement="bottom"
            >
              <app-i18n code="entities.team.list.multipleTeams" />
            </el-tooltip>
          </el-col>
          <!-- Email -->
          <el-col :lg="6" :md="6" :sm="24">
            <span>{{presenterCoach(coach, 'email')}}</span>
          </el-col>
        </el-row>
      </div>


      <!-- Players -->
      <div v-if="record.players.length" class="team-view-page__content__card__title">
        <app-i18n code="entities.player.label"/>
      </div>

      <div v-if="record.players.length" class="team-view-page__content__card">
        <el-row class="team-view-page__content__card__header">
          <!-- Name -->
          <el-col :lg="5" :md="5" :sm="24">
            <app-i18n code="entities.player.fields.name"/>
          </el-col>
          <!-- Program -->
          <el-col :lg="4" :md="4" :sm="24">
            <app-i18n code="entities.player.fields.program" />
          </el-col>
          <!-- Gender -->
          <el-col :lg="3" :md="3" :sm="24">
            <app-i18n code="entities.player.fields.gender" />
          </el-col>
          <!-- Birthdate -->
          <el-col :lg="4" :md="4" :sm="24">
            <app-i18n code="entities.player.fields.birthdate" />              
          </el-col>
          <!-- Category -->
          <el-col :lg="4" :md="4" :sm="24">
            <app-i18n code="entities.team.fields.category" />              
          </el-col>
          <!-- Teams -->
          <el-col :lg="4" :md="4" :sm="24">
            <app-i18n code="entities.player.fields.teams" />              
          </el-col>
        </el-row>
        <el-row class="team-view-page__content__card__body" v-for="player in record.players" :key="player.id">
          <!-- Name -->
          <el-col :lg="5" :md="5" :sm="24">
            <div
              v-if="player.picture.length > 0"
              class="list__avatar"
              :style="{ backgroundImage: getPlayerAvatar(player) }"
            />
            <span
              class="list__avatar__name"
              v-text="`${presenterPlayer(player, 'firstName')} ${presenterPlayer(player, 'lastName')}`"
            />
            <!-- <span>{{presenterPlayer(player, 'firstName')}}  {{presenterPlayer(player, 'lastName')}}</span> -->
          </el-col>
          <!-- Program -->
          <el-col :lg="4" :md="4" :sm="24">
            <span>{{nameProgram}}</span>
          </el-col>
          <!-- Gender -->
          <el-col :lg="3" :md="3" :sm="24">
            <span>{{presenterPlayer(player, 'gender')}}</span>
          </el-col>
          <!-- Birthdate -->
          <el-col :lg="4" :md="4" :sm="24">
            <span>{{presenterPlayer(player, 'birthdate')}}</span>
          </el-col>
          <!-- Subprogram -->
          <el-col :lg="4" :md="4" :sm="24">
            <span v-text="nameSubprogram" />
          </el-col>
          <!-- Teams -->
          <el-col :lg="4" :md="4" :sm="24">
            <app-i18n
              v-if="!player.teams || !player.teams.length"
              code="common.none"
            />
            <span
              v-else-if="player.teams.length === 1"
            >
              {{player.teams[0].name}}
            </span>
            <el-tooltip
              v-else-if="player.teams.length > 1"
              effect="dark"
              :content="player.teams.map(team => team.name).join('\n')"
              placement="bottom"
            >
              <app-i18n code="entities.team.list.multipleTeams" />
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { TeamModel } from '@modules/team/team-model';
import { CoachModel } from '@modules/coach/coach-model';
import { PlayerModel } from '@modules/player/player-model';
import TeamViewToolbar from '@modules/team/components/team-view-toolbar.vue';
import { i18n } from '@shared/i18n';

const { fields } = TeamModel;

export default {
  name: 'app-team-view-page',

  props: ['id'],

  computed: {
    ...mapGetters({
      record: 'team/view/record',
      loading: 'team/view/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    fields() {
      return fields;
    },

    nameProgram() {
      if (this.record.program && this.record.program.name) {
        const {name} = this.record.program;
        return name
      } else {
        return i18n('common.none');
      }

      // if (this.record && this.record.programs) {
      //   const program = Object.values(this.record.programs);
      //   return program[0].label;
      // } else {
      //   return '';
      // }

    }, 

    nameSubprogram() {
      if (this.record.subprogram && this.record.subprogram.name) {
        const {name} = this.record.subprogram;
        return name;
      } else {
        return i18n('common.none');
      }

      // return (programsObject) => {
      //   const subprograms = [];
      //   if (programsObject) {
      //     Object.values(programsObject).forEach(
      //       (programObject) => {
      //         if (!('subprograms' in programObject)) return;
      //         if (!programObject.subprograms) return;
      //         Object.keys(
      //           programObject.subprograms,
      //         ).forEach((subprogramId) => {
      //           subprograms.push({
      //             id: subprogramId,
      //             label:
      //               programObject.subprograms[subprogramId]
      //                 .label,
      //           });
      //         });
      //       },
      //     );
      //   }
      //   return subprograms;
      // };
    }
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'team/view/doFind',
    }),

    presenter(record, fieldName) {
      return TeamModel.presenter(record, fieldName);
    },
    presenterCoach(record, fieldName) {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },
    presenterPlayer(record, fieldName) {
      const { dateFormat, timeFormat } = this;
      return new PlayerModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },
    getPlayerAvatar(player) {
      if (!('picture' in player)) return null;
      if (!(player.picture instanceof Array)) return null;
      if (!player.picture.length > 0) return null;
      if (!player.picture[0].publicUrl) return null;
      return `url("${player.picture[0].publicUrl}")`;
    },
  },
  components: {
    [TeamViewToolbar.name]: TeamViewToolbar,
  },
};
</script>
<style scoped>

.team-view-page__top__buttons {
  display: flex;
  justify-content: space-between;
} .team-view-page__top__buttons__edit__button,
  .team-view-page__top__buttons__add__button {
    padding-right: 3em; 
  }

.team-view-page__content {
  padding: 3em 0 4em 4em;
}

.team-view-page__content__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.team-view-page__content__subtitle {
  text-transform: initial;
  font-size: 24px;
  font-weight: bold;
  color: #4c4c4c;
} .team-view-page__content__subtitle--light {
    font-weight: lighter;
  }

.team-view-page__content__program {
  color: #76787d;
  margin-top: -14px;
}
.team-view-page__content__card__title {
  padding-top: 2em;
  color: #565656;
  font-size: 18px;
  text-transform: uppercase;
}

.team-view-page__content__card {
  -webkit-box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  background-color: #ffffff;
  padding: 2em 3em 2em 3em;
  margin: 1em 0;
  color: rgba(102, 102, 102, 0.74);
} .team-view-page__content__card__header {
    padding-bottom: 1em;
    font-weight: 500;
  }
  .team-view-page__content__card__body {
    padding-top: 1em;
    display: flex;
    align-items: center;
  }

.team-view-page--color-gray {
  color: rgba(102, 102, 102, 0.74);
}

</style>
